export default __webpack_public_path__ + "static/media/fyzika.98d6ed92.svg";